<template>
  <div>
    <div style="display: block;" v-for="(g,l) in dataList" :key="l">
      <div
        v-for="(item,index) in g.children"
        :key="index"
        class="card"
        :id="item.id"
        :style="`border-color: ${$parent.data.type==0?'#761C75':$parent.data.type==1?'#60924D': '#EC8B14'}`"
      >
        <div class="card-img">
          <img :src="item.logo" alt />
        </div>

        <div class="text-content">
          <div class="time" style="display:inline-block">
            <img src="../assets/imgs/shijian.png" alt />
            <span>{{item.scheduleDateTime}}</span>
          </div>
          <div style="flex:1;">
            <h2>{{item.scheduleName}}</h2>
            <div class="ph" v-for="(g,gindex) in item.guestList" :key="gindex">
              <span class="ph-name">{{g.name}}</span>
              <span>{{g.titles}}</span>
            </div>
          </div>
          <div class="card-botton">
            <el-button
              style="background:#D6DFEC;color: #626262;border: none"
              type="primary"
              round
              disabled
              v-if="item.scheduleState == 1"
            >{{$t("message.havenotstarted")}}</el-button>
            <el-button
              @click="playVideo(item.id,item.scheduleState)"
              style="background:rgba(56,107,169,1);color:rgba(255,255,255,1);border: none"
              type="primary"
              round
              v-if="item.scheduleState == 2"
            >直播中</el-button>
            <el-button
              @click="playVideo(item.id,item.scheduleState)"
              style="background:#5E91CA;color:#FFFFFF;border: none"
              type="primary"
              round
              v-if="item.scheduleState == 3"
            >观看回放</el-button>
          </div>
        </div>
        <!-- 1:未开始 2:直播中 3:直播回放 new Date().getFullYear() + '年' +  -->

        <!-- <el-button
          style="background:#D6DFEC;color:#386BAA;border: none"     
          type="primary"
          round
          disabled
        >{{$t("message.over")}}</el-button>-->
      </div>
    </div>
  </div>
</template>
<script>
import { callApi } from "../api/callApi";
import { getToken } from "../utils/auth";
import {
  apiMethod,
  pushLog,
  logProdType,
  targetType,
  eventType,
  pageType
} from "../global/config";
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: {}
    },
    type: {
      type: String,
      default: "0"
    },
    search: {
      type: Function,
      default: null
    },
    onlyLook: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      logo: require("../assets/imgs/shoucang2.png"),
      logoActive: require("../assets/imgs/shoucang (1).png"),
      state: ["观看", "未开始", "直播回放"],
      iconPath: [
        "../assets/imgs/shoucang (1).png",
        "../assets/imgs/shoucang2.png"
      ]
    };
  },
  methods: {
    playVideo(id, type) {
      if (getToken()) {
        this.$c(this.$g.showScheduleOrMaterial, {
          id: id,
          type: "1"
        }).then(response => {
          if (response.code == 200) {
            if (response.success) {
                window.open(response.data.path, "_blank");
            //   this.$c(this.$g.getAssignUser, {
            //     eid: localStorage.getItem("eid"),
            //     url:
            //       this.$i18n.locale == "zh"
            //         ? response.data.path
            //         : response.data.pathEn
            //   }).then(res => {
            //     if (res.code == 200) {
            //       window.open(res.data, "_blank");
            //     }
            //   });
              //   this.Buriedpoint(targetType.AGENDA, id, type);
            } else {
              this.$message({
                message:
                  this.$i18n.locale == "zh"
                    ? response.message.split("/")[0]
                    : response.message.split("/")[1],
                type: "error",
                duration: 3 * 1000
              });
            }
          }
        });
      } else {
        this.$parent.$parent.centerDialogVisible = true;
      }
    },
    Buriedpoint(targetType, id, type) {
      console.log("点击");
      pushLog(
        this,
        logProdType.PC,
        pageType.MUDU,
        type == 2 ? eventType.WATCH_LIVE : eventType.Playback,
        targetType,
        id
      );
    },
    addCollect(val) {
      if (getToken()) {
        if (val.followed != "1") {
          this.$c(this.$g.SET_MY_FOLLOW, {
            targetId: val.id,
            targetType: 0
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                message:
                  this.$i18n.locale == "zh"
                    ? res.message.split("/")[0]
                    : res.message.split("/")[1],
                type: "success"
              });
            }
            this.search();
          });
        } else {
          this.$c(this.$g.SET_BACK_MY_FOLLOW, {
            targetId: val.id,
            targetType: 0
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                message:
                  this.$i18n.locale == "zh"
                    ? res.message.split("/")[0]
                    : res.message.split("/")[1],
                type: "success"
              });
            }
            if (this.checked) {
              this.onlyLook(this.checked);
            } else {
              this.search();
            }
          });
        }
      } else {
        this.$parent.$parent.centerDialogVisible = true;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "@/style/variable.less";
.nav-content {
  width: 1080px;
  margin: 0 auto;

  .cardlist {
    margin-bottom: 48px;
    position: relative;

    // &:nth-child(1) {
    //   margin-top: 0;
    // }

    .card-header {
      background: url("../assets/imgs/bjtx.png") no-repeat;
      background-size: cover;
      color: rgba(254, 254, 254, 1);
      padding: 19px 0 19px 30px;
      box-sizing: border-box;

      span {
        display: inline-block;
        line-height: 1;
        font-size: 18px;
      }
    }

    .vedio-ico {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: rgba(255, 255, 255, 1);
      font-size: 71px;
      cursor: pointer;
    }

    .video-mes {
      background: #2a4982;
      padding: 33px 0 36px 55px;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      box-sizing: border-box;
      opacity: 0.4;

      .card-border-top {
        width: 409px;
        height: 2px;
        background: rgba(56, 107, 169, 1);
        position: absolute;
        top: 0;
        left: 0;
      }

      .time {
        margin: 28px 0 18px 0;

        img {
          height: 26px;
          width: 26px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 13px;
        }

        span {
          vertical-align: middle;
          font-size: 20px;
          line-height: 20px;
          display: inline-block;
          color: rgba(255, 255, 255, 1);
        }
      }

      h2 {
        font-size: 30px;
        color: rgba(255, 255, 255, 1);
        margin-top: 13px;
        line-height: 30px;
      }

      p {
        color: rgba(34, 113, 255, 1);
        font-size: 20px;
        margin-top: 16px;
      }

      .ph {
        color: rgba(255, 255, 255, 1);
        font-weight: 300;
        margin-top: 13px;
      }
    }

    .active {
      &:nth-child(1) {
        .card-border-top {
          display: none;
        }
      }
    }
  }
}
.collect {
  cursor: pointer;
  margin-right: 32px;
  display: inline-block;
  img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 12px;
  }

  span {
    vertical-align: middle;
    font-size: 15px;
    line-height: 15px;
    display: inline-block;
  }
}
.card {
  border: 1px solid rgba(56, 107, 169, 1);
  border-bottom: none;
  position: relative;
  margin-top: 40px;
  background: rgba(255, 255, 255, 1);
  border-bottom: 1px solid rgba(56, 107, 169, 1);
  border-top-width: 8px;
  display: flex;
  &:last-child {
  }
  .card-title {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-title-text {
      font-size: 20px;
      line-height: 20px;
      color: @color-A;
      background: url(../assets/imgs/cardBc.png) no-repeat;
      background-size: 100% 100%;
      display: inline-block;
      width: 80%;
      padding: 19px 37px 19px 24px;
      box-sizing: border-box;
    }
  }
  .card-border-top {
    width: 312px;
    height: 2px;
    background: rgba(56, 107, 169, 1);
    position: absolute;
    top: 0;
    left: 0;
  }

  .img-content {
    height: 240px;
    margin-right: 50px;
    flex: 0 0 395px;
  }
  .card-img {
    flex: 0 0 40%;
    display: flex;
    align-items: center;
    padding-left: 30px;
    box-sizing: border-box;
    img {
      width: 100%;
      border-radius: 5px;
    }
  }
  .text-content {
    position: relative;
    flex: 1;
    padding: 34px 39px 80px 41px;
    min-height: 300px;
    box-sizing: border-box;
    .time {
      flex: 0 0 200px;
      img {
        height: 16px;
        width: 16px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }

      span {
        vertical-align: middle;
        font-size: 16px;
        line-height: 16px;
        display: inline-block;

        color: #626262;
      }
    }

    h2 {
      font-size: 18px;
      color: #386baa;
      margin: 20px 0;
      line-height: 1;
      line-height: 26px;
    }

    p {
      color: #626262;
      font-size: 12px;
      margin-top: 15px;
    }

    .ph {
      color: @text;
      //   font-weight: 300;
      margin-top: 10px;
      font-size: 14px;
      // line-height: 15px;
      display: flex;
      width: 100%;
      span {
        vertical-align: middle;
        // font-weight: bold;
        display: inline-block;
      }
      .ph-name {
        color: #222222;
        font-weight: bold;
        font-size: 15px;
        // margin-right: 20px;
        flex: 0 0 90px;
      }
    }
    .ph-title {
      color: #376ba9;
    }
    .moreTwo {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .card-botton {
      position: absolute;
      right: 40px;
      bottom: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // position: absolute;
      // bottom: 0;
      // right: 0;
      //   width: 100%;

      .el-button {
        width: 180px;
        height: 40px;
        background: rgba(34, 113, 255, 1);
        border-radius: 32px;
        font-size: 15px;
        box-shadow: none;
        margin: 0 auto;
      }
    }
  }
}
</style>